import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LiveClassLessonTrack } from '../../../live-class-lesson-track-dto';

@Component({
  selector: 'lp2-private-class-banner-image',
  template: `
    <div class="py-3 px-0 d-none d-xl-inline-block">
      <div class="position-relative">
        <div [ngClass]="{ lockedOverlay: privateClassesLocked }"></div>
        <i class="fas fa-lock" *ngIf="privateClassesLocked" aria-hidden="true"></i>
        <img class="bigImage" [src]="track.image" />
      </div>
    </div>
  `,
  styleUrls: ['./private-class-banner-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassBannerImageComponent {
  @Input() privateClassesLocked: boolean;
  @Input() track: LiveClassLessonTrack;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-left-header-banner/private-class-banner-image/private-class-banner-image.component.ts